module.exports = __webpack_public_path__ + "static/img/activityCenter.47d2091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activityCenter.png
// module id = H503
// module chunks = 1